export default {
  appName: 'NFC-UID批量获取工具',
  company: '上海秦伏信息科技有限公司',
  nav: {
    home: '首页',
    privacy: '隐私政策',
    support: '技术支持',
    contact: '联系我们'
  },
  home: {
    title: 'NFC-UID批量获取工具',
    subtitle: '强大的NFC标签读写工具',
    description: '轻松读取和写入NFC标签，支持文本、网址、音乐链接、音频、视频、图片等多种数据格式',
    featuresTitle: '核心功能',
    featuresSubtitle: '强大的NFC读写功能，满足您的所有需求',
    features: {
      uidReader: {
        title: 'UID 读取器',
        subtitle: '免费',
        description: '快速读取 NFC 标签 UID，支持导出数据，完全免费使用',
        items: {
          item1: '快速读取 NFC 标签 UID',
          item2: '支持导出数据',
          item3: '完全免费使用'
        }
      },
      freeWrite: {
        title: '免费写入功能',
        subtitle: '简单易用',
        description: '支持文本、网址、音乐链接等基础写入功能',
        items: {
          item1: '文本、网址、音乐链接',
          item2: '简单易用的界面',
          item3: '免费使用'
        }
      },
      advancedWrite: {
        title: '高级写入功能',
        subtitle: '多媒体支持',
        description: '支持音频、视频、图片等多媒体内容写入',
        items: {
          item1: '音频、视频、图片',
          item2: '多媒体支持',
          item3: '高质量内容写入'
        }
      }
    },
    download: '立即下载',
    learnMore: '了解更多',
    comingSoon: '即将推出',
    envPills: ['iOS 16.6 及以上', 'iPhone 7 及后续机型', '支持 NDEF 格式标签'],
    showcase: {
      title: '功能实拍',
      subtitle: '真实界面，所见即所得',
      items: [
        { title: '多媒体写入', desc: '照片、音频、视频、文本、定制芯片五种标签类型' },
        { title: '基础写入', desc: '文本、网址、音乐链接等七种数据，即写即用' },
        { title: 'UID 读取器', desc: '连续扫描批量读取，支持导出记录' },
        { title: '标签套餐', desc: '按类型选购套餐，支付后配额自动到账' }
      ]
    },
    steps: {
      title: '四步完成写入',
      subtitle: '无需专业知识，拿起手机就能用',
      items: [
        { title: '选择标签类型', desc: '照片、音频、视频、文本等多种芯片可选' },
        { title: '填写内容', desc: '上传文件或填写文本，实时预览确认' },
        { title: '贴近写入', desc: '将标签靠近 iPhone 背面，几秒即可完成' },
        { title: '触碰访问', desc: '他人手机碰一碰标签，即可查看内容' }
      ]
    },
    scenes: {
      title: '适用场景',
      subtitle: '一枚小标签，装下大世界',
      items: [
        { title: '个人物品管理', desc: '给物品贴上标签，信息随手可查' },
        { title: '智能名片', desc: '碰一碰交换联系方式与作品' },
        { title: '产品展示', desc: '标签贴上商品，客户触碰看详情' },
        { title: '营销推广', desc: '海报展台加标签，引流更高效' }
      ]
    }
  },
  privacy: {
    title: '用户隐私协议',
    effectiveDate: '2025年9月17日',
    lastUpdated: '最后更新',
    intro: 'NFC-UID批量获取工具（由上海秦伏信息科技有限公司运营，以下简称"我们"或"本应用"）非常重视您的隐私保护。本隐私协议旨在向您说明我们如何收集、使用、存储和保护您的个人信息。在使用本应用之前，请您仔细阅读本隐私协议。',
    sections: {
      infoCollection: {
        title: '信息收集范围',
        account: {
          title: '账户信息',
          content: '我们收集以下账户相关信息，用于为您提供账户注册、登录和管理服务：',
          items: ['邮箱地址：用于账户注册、登录、接收验证码和密码重置', '密码：经过加密处理后存储，用于账户安全验证', '用户名：用于在应用中显示您的身份', '手机号码（可选）：用于账户验证和联系', '头像链接：用于个性化展示您的账户信息', '用户ID：系统自动生成的唯一标识符']
        },
        thirdParty: {
          title: '第三方登录信息',
          content: '当您选择使用Apple登录时，我们收集：',
          items: ['Apple ID凭证：用于身份验证', 'Apple登录Token：用于维护您的登录状态']
        },
        nfc: {
          title: 'NFC功能相关数据',
          content: '当您使用NFC功能时，我们可能收集：',
          items: ['NFC标签UID：用于识别和记录您扫描的NFC标签', 'NFC写入内容：包括文本、网址、音乐链接、音频、视频、图片等您选择写入标签的内容', '扫描记录：包括扫描时间、标签类型、连接质量等技术信息', '导出数据：您可以选择将扫描记录导出为CSV文件']
        },
        files: {
          title: '文件上传数据',
          content: '当您使用高级写入功能上传多媒体文件时：',
          items: ['文件内容：您上传的音频、视频、图片文件', '文件元数据：文件大小、文件类型、文件名等信息', '上传记录：文件上传状态和结果'],
          note: '注：文件通过腾讯云对象存储（COS）服务进行存储和传输。'
        },
        payment: {
          title: '支付信息',
          content: '当您使用支付功能时，我们收集：',
          items: ['订单信息：订单ID、支付金额、支付状态', '支付平台：支付宝等第三方支付平台返回的支付信息', '支付结果：用于确认支付状态和完成订单'],
          note: '注：我们不会收集或存储您的银行卡号、支付密码等敏感支付信息，这些信息由第三方支付平台（支付宝）直接处理。'
        },
        device: {
          title: '设备信息',
          content: '为了提供更好的服务体验，我们可能收集：',
          items: ['设备标识符：用于设备识别和服务优化', '应用版本信息：用于版本更新和兼容性处理', '系统语言设置：用于提供本地化服务']
        },
        usage: {
          title: '使用数据',
          content: '我们可能收集以下使用数据：',
          items: ['功能使用记录：您使用各项功能的频率和方式', '错误日志：用于改进应用稳定性和性能', '网络请求信息：用于服务优化和问题排查']
        }
      },
      infoUsage: {
        title: '信息使用目的',
        content: '我们收集您的个人信息用于以下目的：',
        items: ['提供服务：提供NFC标签读写、数据管理、账户管理等核心功能', '账户管理：注册、登录、身份验证、密码重置等账户相关服务', '支付处理：处理订单支付、查询支付状态、完成交易', '文件存储：存储您上传的多媒体文件，以便通过NFC标签访问', '服务改进：分析使用情况，优化应用功能和性能', '安全保护：检测和防范安全威胁、欺诈行为', '客户支持：响应您的咨询、反馈和投诉', '合规要求：遵守法律法规要求，配合监管机构调查']
      },
      infoStorage: {
        title: '信息存储和保护',
        local: {
          title: '本地存储',
          content: '以下信息存储在您的设备本地：',
          items: ['认证Token：存储在UserDefaults中，用于维护登录状态', '应用设置：语言偏好、主题设置等本地配置', '扫描记录：您在本地的NFC扫描数据（可选导出）']
        },
        server: {
          title: '服务器存储',
          content: '以下信息存储在服务器：',
          items: ['账户信息：邮箱、用户名、加密密码等', 'NFC卡片数据：您创建的NFC卡片信息', '上传文件：通过COS服务存储的多媒体文件', '订单记录：支付和订单相关数据']
        },
        security: {
          title: '数据安全措施',
          content: '我们采取以下措施保护您的信息安全：',
          items: ['加密传输：使用HTTPS协议加密传输数据', '密码加密：用户密码经过加密处理存储', '访问控制：限制员工对用户数据的访问权限', '安全审计：定期进行安全审计和漏洞检测', '数据备份：定期备份重要数据，防止数据丢失']
        }
      },
      thirdPartyServices: {
        title: '第三方服务',
        items: [
          { name: '腾讯云对象存储（COS）', purpose: '存储您上传的音频、视频、图片文件', data: '您上传的文件内容', policy: 'https://cloud.tencent.com/document/product/436/7758' },
          { name: '支付宝', purpose: '处理支付交易', data: '订单信息、支付金额、支付状态', policy: 'https://render.alipay.com/p/c/180020270001236236' },
          { name: 'Apple登录', purpose: '提供Apple账户登录功能', data: 'Apple ID凭证、登录Token', policy: 'https://www.apple.com/privacy/' },
          { name: 'App Store', purpose: '应用分发和更新检查', data: '应用版本信息', policy: 'https://www.apple.com/privacy/' }
        ]
      },
      infoSharing: {
        title: '信息共享和披露',
        noSale: '我们不会出售您的个人信息',
        noSaleContent: '我们不会向第三方出售、交易或出租您的个人信息。',
        shareTitle: '以下情况可能共享信息',
        shareItems: ['服务提供商：与为我们提供服务的第三方（如云存储、支付处理）共享必要信息', '法律要求：根据法律法规、法院判决或政府要求', '安全保护：为保护我们的权利、财产或用户安全', '业务转让：在合并、收购或资产转让时（会提前通知您）']
      },
      userRights: {
        title: '您的权利',
        content: '您对个人信息享有以下权利：',
        items: ['访问权：查看我们收集的您的个人信息', '更正权：更正不准确或不完整的个人信息', '删除权：请求删除您的个人信息（需符合法律要求）', '撤回同意：撤回对个人信息处理的同意', '数据导出：导出您的个人数据（NFC扫描记录等）', '账户注销：注销账户并删除相关数据'],
        contact: '如需行使上述权利，请通过以下方式联系我们：',
        contactMethods: ['邮箱：support@qinfu-cloud.cn', '应用内：设置页面 - 技术支持']
      },
      childrenPrivacy: {
        title: '儿童隐私保护',
        content: '本应用不面向13岁以下（或您所在地区法律规定的年龄）的儿童。我们不会故意收集儿童的个人信息。如果我们发现收集了儿童信息，将立即删除相关数据。'
      },
      dataRetention: {
        title: '数据保留',
        content: '我们仅在为实现本隐私协议所述目的所必需的期间内保留您的个人信息：',
        items: ['账户信息：在您账户有效期间及注销后的一段时间（符合法律要求）', 'NFC数据：在您删除前或账户注销后保留', '支付记录：根据法律法规要求保留（通常为5-7年）', '日志数据：通常保留90天']
      },
      international: {
        title: '国际数据传输',
        content: '您的个人信息可能被传输到您所在国家/地区以外的地方进行处理和存储。我们确保采取适当的安全措施保护您的数据。'
      },
      policyUpdate: {
        title: '隐私协议更新',
        content: '我们可能会不定期更新本隐私协议。重大变更时，我们会在应用中通知您。继续使用本应用即表示您接受更新后的隐私协议。'
      },
      contactUs: {
        title: '联系我们',
        content: '如果您对本隐私协议有任何疑问、意见或投诉，请通过以下方式联系我们：',
        items: ['公司名称：上海秦伏信息科技有限公司', '应用名称：NFC-UID批量获取工具', '联系邮箱：support@qinfu-cloud.cn', '应用内支持：设置 - 技术支持']
      },
      law: {
        title: '适用法律',
        content: '本隐私协议的制定、执行和解释均适用中华人民共和国法律。如发生争议，应友好协商解决；协商不成的，任何一方均可向有管辖权的人民法院提起诉讼。'
      },
      notice: {
        title: '重要提示',
        content: '使用本应用即表示您已阅读、理解并同意本隐私协议的全部内容。如果您不同意本协议的任何条款，请停止使用本应用。'
      }
    }
  },
  support: {
    title: '技术支持',
    content: '如果您在使用过程中遇到任何问题，请通过以下方式联系我们：',
    email: '邮箱',
    emailDescription: '通过邮件联系我们',
    sendEmail: '发送邮件',
    faq: '常见问题',
    faqDescription: '查看常见问题解答',
    viewFAQ: '查看FAQ',
    faqTitle: '常见问题',
    faqItems: {
      read: {
        question: '如何读取NFC标签？',
        answer: '打开应用后，将您的设备靠近NFC标签，应用会自动检测并读取标签信息。'
      },
      types: {
        question: '支持哪些类型的NFC标签？',
        answer: '我们支持符合ISO14443和ISO15693协议的NFC标签。'
      },
      pricing: {
        question: '高级功能需要付费吗？',
        answer: '基础功能（UID读取、文本写入）完全免费。高级功能（多媒体写入）需要升级到高级版本。'
      }
    },
    audioGuide: {
      title: '如何写入音频文件',
      step1: {
        title: '步骤一：选择音频文件',
        description: '在您的设备上选择音频文件，点击分享按钮'
      },
      step2: {
        title: '步骤二：存储到文件',
        description: '在分享菜单中选择"存储到文件"选项'
      },
      step3: {
        title: '步骤三：在应用中上传',
        description: '打开NFC-UID批量获取工具应用，选择保存的文件并上传'
      }
    },
    videoGuide: {
      title: '视频教程',
      description: '观看我们的视频教程，了解更多使用技巧',
      bilibili: {
        title: '哔哩哔哩教程',
        watch: '观看视频'
      },
      youtube: {
        title: 'YouTube教程',
        watch: '观看视频'
      }
    },
    completeGuide: {
      title: '全部使用教程',
      description: '完整的使用教程，包含所有功能的使用方法',
      bilibili: {
        title: '哔哩哔哩完整教程',
        watch: '观看完整教程'
      },
      stepsTitle: '使用步骤'
    }
  },
  contact: {
    title: '联系我们',
    subtitle: '我们很乐意听到您的声音',
    email: '邮箱',
    phone: '电话',
    address: '地址',
    wechat: '微信公众号',
    scanToFollow: '扫码关注我们'
  },
  footer: {
    copyright: '版权所有',
    allRightsReserved: '保留所有权利',
    contactUs: '联系我们',
    privacy: '隐私政策',
    terms: '使用条款',
    quickLinks: '快速链接',
    wechat: '微信公众号',
    scanQR: '扫码关注'
  }
}

